<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">首页</div>
                    <div class="navigation_img"></div>
                        <div class="navigation_text">联盟出版书籍</div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">当前所在位置：</div>
                        <div class="navigation_index" @click="goIndex">首页</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">联盟出版书籍</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box" v-if="bookList.length>0">
                        <div class="news_right_bottom_item" @click="linkToDetails(item)" v-for="(item,index) in bookList" :key="index">
                            <div class="news_right_bottom_item_left">
                                <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                            </div>
                            <div class="news_right_bottom_item_right">
                                <div class="news_right_bottom_item_right_top">{{item.title}}</div>
                                <div class="news_right_bottom_item_right_time">
                                    发布时间：
                                    {{item.publishTime?handleTime(item.publishTime):''}}
                                </div>
                                <div class="news_right_bottom_item_right_bottom">{{item.profile}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom_none" v-if="bookList.length == 0">暂无数据</div>
                    <!-- 分页 -->
                    <el-pagination
                        :current-page="query.current"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange"
                        background
                        :total="total"
                        :pager-count="5"
                        layout="prev, pager, next">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {newsList } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            typeList: [],
            total: null,
            query: {
                current: this.$route.query.current? Number(this.$route.query.current) : 1,
                pageSize: 12,
                model:5,
                newsType: '',
                lang:1
            },
            bookList: []
        }
    },
    created() {
        this.getBooks()
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        // 获取新闻列表
        async getBooks() {
            this.loading = true // loading start
            let res = await newsList(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.total = res.data.total
            this.bookList = res.data.records
            setTimeout(() => {
                this.restoreScrollPosition()
            }, 500);
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getBooks()
            this.getScroll()
        },
        // 跳转详情
        linkToDetails(item) {
            if(item.link) {
                window.open(item.link, '_blank');
            } else {
                this.$router.push({name: 'specifics', params: { name: 'books', type: 0, id: item.id,current:this.query.current } })
            }
        },
        goIndex() {
            this.$router.push('/index')
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'.'+month+'.'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        restoreScrollPosition() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition) {
                // 恢复滚动位置
                $('html, body').animate({scrollTop: scrollPosition}, 100)
                setTimeout(() => {
                    window.sessionStorage.removeItem('scrollPosition'); // 清除存储的滚动位置，防止重复使用
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if(to.name == "specifics") {
            window.sessionStorage.setItem('scrollPosition', window.scrollY);
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 80px 0;
    .news_box {
        .news_right {
            width: 100%;
            .news_right_top {
                margin-bottom: 20px;
            }
            .news_right_bottom {
                .news_right_bottom_box {
                    margin-bottom: 80px;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 30px;
                    .news_right_bottom_item {
                        width: calc((100% - 30px) / 2);
                        padding: 25px;
                        background-color: #ffffff;
                        display: flex;
                        cursor: pointer;
                        .news_right_bottom_item_left {
                            width: 222px;
                            height: 148px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-right: 25px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                            .none_img {
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                        .news_right_bottom_item_right {
                            width: calc(100% - 222px - 25px);
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            padding: 5px 0;
                            .news_right_bottom_item_right_top {
                                color: #000000;
                                font-size: 20px;
                                font-weight: bold;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .news_right_bottom_item_right_time {
                                font-size: 16px;
                                color: #787878;
                            }
                            .news_right_bottom_item_right_bottom {
                                font-size: 16px;
                                color: #787878;
                                line-height: 2;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                        }
                    }
                    .news_right_bottom_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_bottom_item_right {
                            .news_right_bottom_item_right_top {
                                color: #0085D0;
                                text-decoration: underline;
                                text-underline-offset: 3px;
                            }
                        }
                    }
                }
                .news_right_bottom_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ffffff;
                    min-height: 200px;
                    font-size: 16px;
                    margin-bottom: 60px;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            .news_right {
                width: 100%;
                .news_right_bottom {
                    padding-top: 0.2rem;
                    .news_right_bottom_box {
                        margin-bottom: 0.6rem;
                        display: flex;
                        flex-direction: column;
                        gap: 0.2rem;
                        .news_right_bottom_item {
                            width: 100%;
                            padding: 0.2rem;
                            .news_right_bottom_item_left {
                                width: 2.3rem;
                                height: 2.3rem;
                                margin-right: 0.3rem;
                            }
                            .news_right_bottom_item_right {
                                width: calc(100% - 2.3rem - 0.3rem);
                                padding: 0.2rem 0;
                                .news_right_bottom_item_right_top {
                                    font-size: 0.3rem;
                                }
                                .news_right_bottom_item_right_time {
                                    font-size: 0.26rem;
                                }
                                .news_right_bottom_item_right_bottom {
                                    font-size: 0.26rem;
                                    line-height: 1.6;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 1;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                }
                            }
                        }
                    }
                    .news_right_bottom_none {
                        min-height: 3rem;
                        font-size: 0.3rem;
                        margin-bottom: 0.6rem;
                    }
                }
            }
        }
    }

}

</style>